import { useQuery } from '@apollo/client';
import { GET_ALL_PROGRAMS } from '../queries/programs';

export const useFetchAllPrograms = () => {
  const { data, loading, error } = useQuery(GET_ALL_PROGRAMS);

  return {
    programs: data?.programs || [],
    loading,
    error,
  };
};
